import { axiosGet } from '../../shared/utils/apiUtils'
import { User } from './types'

const getUsers = (): Promise<Array<User>> => axiosGet('/v1/user/users')

export { getUsers }
